import { createSelector } from 'reselect';

const searchSelector = ({ search }) => search || {};

const querySelector = createSelector(searchSelector, ({ query }) => query || {});
const keywordsSelector = createSelector(querySelector, ({ keywords }) => keywords) as unknown as (
  state: ReduxState,
) => string | null | undefined;

export { keywordsSelector };
